var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-page',{attrs:{"title":"Training Videos"}},[_c('div',{staticClass:"page text-center justify-content-center"},[_c('div',{staticClass:"accordion-header mt-2 mx-2"},[_c('h1',[_vm._v("Scan the code")])]),_c('img',{attrs:{"src":require("../../../assets/img/framek.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }